const rPaths = {
  rPaths: {
    academy: 'academia',
    account: 'mi-cuenta',
    accessDenied: 'acceso-denegado',
    asset: 'curso',
    billing: 'gestion',
    clearCache: 'limpiar-cache',
    confirmForgotPassword: 'nueva-contraseña',
    editor: 'editor',
    initialAccess: 'acceso-inicial',
    initialSetup: 'configuracion-inicial',
    forgetPassword: 'recuperar-contraseña',
    login: 'login',
    map: 'mapa',
    maps: 'mapas',
    notFound: 'no-encontrado',
    product: 'producto',
    products: 'productos',
    projects: 'formaciones',
    updateMyPlan: 'actualizar-mi-plan',
    updatingLicence: 'actualizar-licencia'
  }
}

export default rPaths
